import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'myfilter',
    pure: false
})

export class Myfilterpipe implements PipeTransform {
    transform(items: any[], selectedCargaId: any[]): any {
        /*if (!items || !selectedCargaId) {
            return items;
        }*/
        console.log(JSON.stringify(items));
        items = selectedCargaId;
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        //return items.filter(item => item.options.cargaId === selectedCargaId);
        return items;
    }
}
